export default "__VITE_ASSET__BvCSk8Dk__"